// React
import React, { Component } from "react";

import './article.css';

const Article = (props) => (

 <div className="article">
    <a href={props.url}>
        <div className="article-title">{ props.title }</div>

        <div className="info-row">
            <div className={"article-timestamp " + props.timestampClass}> { props.timestamp }</div>
            <div className="article-source"> { props.source } </div>
        </div>
    </a>
 </div>

);

export default Article;


// WEBPACK FOOTER //
// ./src/Views/News/Article.js